import React, { useState, useEffect } from 'react';
import logo from '../../assets/logo.png';
import play from '../../assets/play.png';
import Spinner from 'react-spinner-material';
import ResultText from '../Result/ResultText';

import GoogleLogin from 'react-google-login';

import './styles.css'
import Snackbar from '@material-ui/core/Snackbar';

import * as firebase from 'firebase';
import settings from '../../settings'

var app = firebase.initializeApp(settings.configFirebase);

var provider = new firebase.auth.FacebookAuthProvider();
provider.addScope('public_profile');
provider.addScope('email');
provider.addScope('user_friends');

export default function Login({ history }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [userId, setUserId] = useState('');
  const [userPicture, setUserPicture] = useState('');
  const [runLoad, setRunLoad] = useState(false);
  const [openToast, setOpenToast] = useState(false);

  useEffect(() => {
    if (localStorage){
      if(localStorage.getItem("userId")){
        if (localStorage.getItem("userId") != '' && localStorage.getItem("userId") !== undefined && localStorage.getItem("userId") !== null) {
          console.log(localStorage.getItem("userId"))
          getUserData();
        } else {
          console.log(localStorage.getItem("userId"))
        }
      }else{
        console.log('User is not logged in')
      }
    }else {
      console.log('User is not logged in')
    }
    setRunLoad(false);
  }, [userId])

  function handleWithoutLogin() {
    localStorage.setItem("facebookLogin", false);
    history.push('/home')
  }


  function handleCloseErrorInLogin() {
    setOpenToast(false)
  }

  function handleErrorInLogin() {
    setOpenToast(true)
  }

  function getUserData() {
    var numberResult = 0
    var number = 0
    var qtComments = 0
    var deviceId = 0
    var whoLiked = 0
    var qtLikes = 0
    var feito = false
    var perfil1 = 0
    var perfil2 = 0
    var perfil3 = 0
    var perfil4 = 0
    var perfil5 = 0
    var perfil6 = 0
    var perfil7 = 0
    var perfil8 = 0
    var perfil9 = 0

    firebase.database().ref('/usuarios/' + userId).once('value').then(function (snapshot) {
      console.log("Getting user data!")
      qtComments = (snapshot.val() && snapshot.val().qtComments) || 0;
      qtLikes = (snapshot.val() && snapshot.val().qtLikes) || 0;
      deviceId = (snapshot.val() && snapshot.val().deviceId) || '';
      whoLiked = (snapshot.val() && snapshot.val().whoLiked) || [];
      const resultCheck = snapshot.val() && snapshot.val().resultado
      if(resultCheck != undefined && resultCheck != null){
        number = (snapshot.val() && snapshot.val().resultado.resultadoPerfilNumero) || 0;
        numberResult = (snapshot.val() && snapshot.val().resultado.max) || 0;
        feito = (snapshot.val() && snapshot.val().resultado.feito) || false;
        perfil1 = (snapshot.val() && snapshot.val().resultado.perfil1) || 0;
        perfil2 = (snapshot.val() && snapshot.val().resultado.perfil2) || 0;
        perfil3 = (snapshot.val() && snapshot.val().resultado.perfil3) || 0;
        perfil4 = (snapshot.val() && snapshot.val().resultado.perfil4) || 0;
        perfil5 = (snapshot.val() && snapshot.val().resultado.perfil5) || 0;
        perfil6 = (snapshot.val() && snapshot.val().resultado.perfil6) || 0;
        perfil7 = (snapshot.val() && snapshot.val().resultado.perfil7) || 0;
        perfil8 = (snapshot.val() && snapshot.val().resultado.perfil8) || 0;
        perfil9 = (snapshot.val() && snapshot.val().resultado.perfil9) || 0;
      }

      localStorage.setItem("numberResult", numberResult);
      localStorage.setItem("number", number);
      localStorage.setItem("typeAndName", ResultText.type_and_name[number - 1]);
      localStorage.setItem("qtComments", qtComments);
      localStorage.setItem("qtLikes", qtLikes);
      localStorage.setItem("perfil1", perfil1);
      localStorage.setItem("perfil2", perfil2);
      localStorage.setItem("perfil3", perfil3);
      localStorage.setItem("perfil4", perfil4);
      localStorage.setItem("perfil5", perfil5);
      localStorage.setItem("perfil6", perfil6);
      localStorage.setItem("perfil7", perfil7);
      localStorage.setItem("perfil8", perfil8);
      localStorage.setItem("perfil9", perfil9);
      localStorage.setItem("feito", feito);
      localStorage.setItem("deviceId", deviceId);
      localStorage.setItem("whoLiked", JSON.stringify(whoLiked));
      history.push('/home')

      const userLogged = {
        deviceId: deviceId,
        whoLiked: whoLiked,
        email: localStorage.getItem("email"),
        id: localStorage.getItem("userId"),
        imagemPerfil: localStorage.getItem("userPicture"),
        nome: localStorage.getItem("name"),
        qtComments: qtComments,
        qtLikes: qtLikes,
        resultado: {
          feito: feito,
          max: numberResult,
          perfil1: perfil1,
          perfil2: perfil2,
          perfil3: perfil3,
          perfil4: perfil4,
          perfil5: perfil5,
          perfil6: perfil6,
          perfil7: perfil7,
          perfil8: perfil8,
          perfil9: perfil9,
          resultadoPerfilNome: ResultText.type_and_name[number - 1],
          resultadoPerfilNumero: number
        }
      }
      console.log("Home")
      console.log("User Logged")
      console.log(userLogged)
      localStorage.setItem('userLogged', JSON.stringify(userLogged));
    })
  }

  function handleLoginFacebook() {
    setRunLoad(true);

    firebase.auth().signInWithPopup(provider)
      .then(function (result) {
        var token = result.credential.accessToken;
        console.log(result);
        fetch(`https://graph.facebook.com/me?access_token=${token}`)
          .then(function (response) {
            try {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error("HTTP status " + response.status);
              }
            } catch (error) {
              console.log('Error getting response id user');
              return response.json();
            }
          })
          .then(response => {
            console.log(response)
            var userPictureInternal = ''
            try {
              setUserPicture(`https://graph.facebook.com/${response.id}/picture?type=large`)
              userPictureInternal = `https://graph.facebook.com/${response.id}/picture?type=large`
              console.log(`https://graph.facebook.com/me?access_token=${token}`)
            } catch (error) {
              console.log('Error getting user image')
              setUserPicture('')
            }
            localStorage.setItem("name", response.name);
            localStorage.setItem("userId", response.id);
            localStorage.setItem("userPicture", userPictureInternal);
            localStorage.setItem("email", result.user.email);
            localStorage.setItem("token", token);
            localStorage.setItem("facebookLogin", true);
            setEmail(result.user.email)
            setName(response.name);
            setUserId(response.id);
            console.log("Seted user id")
          });
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        var email = error.email;
        var credential = error.credential;
        handleErrorInLogin()
        console.log("ERROR!")
        console.log(error)
        console.log(openToast)
        setRunLoad(false);
      });
  }

  const responseGoogle = (response) => {
    console.log(response);
  }

  return (
    <div>
      <span className='logo-container'>
        <img className='logo-css' src={logo} alt="Logo Teste Eneagrama" />
      </span>

      <span className='spinner' id='load'>
        <Spinner size={60} spinnerColor={"#449AE2"} visible={runLoad} />
      </span>

      <p className='title-page-login'>ESCOLHA SUA FORMA DE LOGIN</p>
      <p className='text-login '>Faça login para salvar o seu resultado e ter acesso de qualquer dispositivo além de ter acesso ao resultado dos seus amigos do Facebook!</p>

      {/*
        <GoogleLogin
          clientId="609512024385"
          buttonText="LOGIN COM GMAIL"
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
        />
        <br />
        <br />
        */
      }

      <button className='btn' onClick={handleLoginFacebook}>LOGIN COM FACEBOOK</button>
      <button className='btn' onClick={handleWithoutLogin}>FAZER O TESTE SEM LOGIN</button>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        key={'bottom,center'}
        open={openToast}
        autoHideDuration={4000}
        onClose={handleCloseErrorInLogin}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={<span id="message-id">Erro ao fazer login, tente novamente!</span>}
      />
    </div>
  );
}